import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { IEmailShippingProp } from '../../../components/usersDetails/Users';
import CustomTooltip from '../../../../components/common/tooltip';
import { FieldLabel } from '@measured/puck';
import ShowComponent from '../../../components/showComponents';
import QuilHelper from '../quilHelper';

interface EmailContentProps {
  value: IEmailShippingProp;
  onChange: (_value: IEmailShippingProp) => void;
  title: string;
  showComponent?: boolean;
  showHover?: boolean;
  showContent?: boolean;
  id: number;
}

const EmailContent: React.FC<EmailContentProps> = ({
  value,
  onChange,
  title,
  showContent = true,
  id,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleHeader = (k: string) => {
    value.text = k;
    onChange({ ...value, text: k });
  };
  const handleFeild = (k: string) => {
    value.content = k;
    onChange({
      ...value,
      content: k,
    });
  };
  return (
    <div>
      <div
        className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
        onClick={() => setIsOpen(!isOpen)}>
        <h3>{title}</h3>
        {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </div>
      {isOpen && (
        <div className="flex flex-col gap-4 mt-3  border border-gray-300 rounded p-2 w-full">
          <ShowComponent
            value={value.showComponent}
            onChange={showComponent => onChange({ ...value, showComponent })}
          />

          <FieldLabel
            label={
              (
                <CustomTooltip title="QuillEditor">
                  <span>{`${title} Header`}</span>
                </CustomTooltip>
              ) as React.ReactNode as string
            }
            el="div">
            <QuilHelper
              value={value.text}
              onChange={handleHeader}
              enableLink={true}
              id={id}
            />
          </FieldLabel>
          {showContent && (
            <div>
              <FieldLabel
                label={
                  (
                    <CustomTooltip title="QuillEditor">
                      <span>{`${title} Field`}</span>
                    </CustomTooltip>
                  ) as React.ReactNode as string
                }
                el="div">
                <QuilHelper
                  value={value.content}
                  onChange={handleFeild}
                  enableLink={true}
                  id={id + 100}
                />
              </FieldLabel>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default EmailContent;
